import SovietsSwitcher from './sovietsSwitcher'

$('.js__sovietsSwitcher').each(function() {
  const options = JSON.parse($(this).attr('data-options') || null)

  $(this).reactify(SovietsSwitcher, options)
  $(this).children().unwrap()
})
